import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import useGetCkPromoFromDiscountContext from './useGetCkPromoFromDiscountContext';

export default function useTrackCreditKarmaPromo() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { shouldShowCkPromo } = useGetCkPromoFromDiscountContext();

  useEffect(() => {
    if (shouldShowCkPromo) {
      trackEvent('credit-karma-promo-displayed');
    }
  }, [shouldShowCkPromo, trackEvent]);
}
